import { FC } from 'react';

import { CheckoutConfirmationSaleItems } from 'src/pages/Checkout/components/SaleItems';
import { CheckoutConfirmCrowdfundingRewards } from 'src/pages/Checkout/components/CrowdfundingRewards';
import { CheckoutConfirmationEventRegistrations } from 'src/pages/Checkout/components/EventRegistrations';
import { CheckoutConfirmationTeamMemberPayments } from 'src/pages/Checkout/components/TeamMemberPayments';
import { CheckoutConfirmationSweepstakesTickets } from 'src/pages/Checkout/components/SweepstakesTickets';
import { CheckoutConfirmationRaffleTickets } from 'src/pages/Checkout/components/RaffleTickets';
import { CheckoutConfirmationAuctionBuyItNowItems } from 'src/pages/Checkout/components/AuctionBuyItNowItems';
import { CheckoutConfirmationAuctionBids } from 'src/pages/Checkout/components/AuctionBids';
import { CheckoutConfirmationResponseType } from 'src/models/Checkout/Confirmation';
import { CheckoutConfirmationAuctionGift } from 'src/pages/Checkout/components/AuctionGift';
import { CheckoutTicketingGroupRegistrations } from 'src/pages/Checkout/components/TicketingGroupRegistrations';
import { CheckoutTicketingGroupTicketRegistrations } from 'src/pages/Checkout/components/TicketingGroupTicketRegistrations';

type Props = {
  model: CheckoutConfirmationResponseType;
};

export const CheckoutConfirmationItemsSummary: FC<Props> = ({ model }) =>
  model.ShowItemsSummarySection ? (
    <>
      {model.SaleItemsSubSection.IsVisible && <CheckoutConfirmationSaleItems model={model.SaleItemsSubSection} />}
      {model.CrowdfundingRewardsSubSection.IsVisible && (
        <CheckoutConfirmCrowdfundingRewards model={model.CrowdfundingRewardsSubSection} />
      )}
      {model.EventRegistrationsSubSection.IsVisible && (
        <CheckoutConfirmationEventRegistrations model={model.EventRegistrationsSubSection} />
      )}
      {model.TicketingGroupRegistrationsSubsection.IsVisible && (
        <CheckoutTicketingGroupRegistrations model={model.TicketingGroupRegistrationsSubsection} />
      )}
      {model.TicketingGroupTicketRegistrationsSubsection.IsVisible && (
        <CheckoutTicketingGroupTicketRegistrations model={model.TicketingGroupTicketRegistrationsSubsection} />
      )}
      {model.TeamMemberPaymentsSubSection.IsDueLater && model.TeamMemberPaymentsSubSection.IsVisible && (
        <CheckoutConfirmationTeamMemberPayments model={model.TeamMemberPaymentsSubSection} />
      )}
      {model.SweepstakesTicketsSubSection.IsVisible && (
        <CheckoutConfirmationSweepstakesTickets model={model.SweepstakesTicketsSubSection} />
      )}
      {model.RaffleTicketsSubSection.IsVisible && (
        <CheckoutConfirmationRaffleTickets model={model.RaffleTicketsSubSection} />
      )}
      {model.AuctionBuyItNowItemsSubSection.IsVisible && (
        <CheckoutConfirmationAuctionBuyItNowItems model={model.AuctionBuyItNowItemsSubSection} />
      )}
      {model.AuctionBidsSubSection.IsVisible && <CheckoutConfirmationAuctionBids model={model.AuctionBidsSubSection} />}
      {model.AuctionGiftSubSection.IsVisible && <CheckoutConfirmationAuctionGift model={model.AuctionGiftSubSection} />}
      {!model.TeamMemberPaymentsSubSection.IsDueLater && model.TeamMemberPaymentsSubSection.IsVisible && (
        <CheckoutConfirmationTeamMemberPayments model={model.TeamMemberPaymentsSubSection} />
      )}
    </>
  ) : null;
